import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MobileCTA } from 'www-cms';
import { DirectusDirective } from 'directus';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { ButtonLinkComponent } from 'building-blocks/button-link/button-link.component';

@Component({
  selector: 'ss-www-mobile-cta',
  imports: [ButtonLinkComponent, DirectusDirective],
  templateUrl: './mobile-cta.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileCtaComponent extends BaseBuildingBlockComponent {
  override getBgClass(): LastItemBgClass {
    return 'bg-ss-www-background';
  }
  @Input({ required: true }) mobileCTAData!: MobileCTA;
}
